import * as Yup from 'yup';

export const replicateProjectModel = {
  name: '',
  description: '',
  selected_plant: null,
  themes: [],
  project_owners: [],
  stage_template_id: '',
};

export const replicateProjectFormValidation = Yup.object().shape({
  name: Yup.string().required('Project name is required'),
  selected_plant: Yup.object().required().typeError('Plant is required'),
});
